import { Spin } from 'antd';
// import { PlusCircleOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CreateStudioModal } from '../create-studio';
import { EmptyStudio } from '../empty-studio';
import { IAPIGameItem } from '../../../model/api-modules';
import { IRootState } from '../../../store/reducers';

import styles from './index.module.scss';
import { GamesAction } from '../../../store/modules/games';
import {
  getStudioList,
  ISelectStudioAction,
  ReduxStudioActionType,
  StudioAction,
} from '../../../store/modules/studio';
import { ApplyToJoinModal } from '../apply-studio';
import { Dispatch } from 'redux';
import { StudioItem } from './studio-item';
import { SimpleCardWrapper } from '../../component/in-game/simple-card';
import { Header } from '../../component/header';
import CreatNewStudio from '../../../assets/svg/create-new-studio.svg';
import getFormatMessage from '../../../locales/get-format-message';
import { isSupportUser } from '../../lib';
import { wrapTimeReport } from '../../lib/bk-report';

export const SelectStudioRouter = () => {
  const history = useHistory();
  const gameStudioDispatch =
    useDispatch<Dispatch<StudioAction | GamesAction>>();
  const selectStudioDispatch = useDispatch<Dispatch<ISelectStudioAction>>();
  const studioList = useSelector(
    (state: IRootState) => state.studio.studioList
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [showCreateStudioModal, setShowCreateStudioModal] =
    useState<boolean>(false);
  const [showApplyJoinModal, setShowApplyJoinModal] = useState<boolean>(false);
  const [showPage, setShowPage] = useState<boolean>(false);

  useEffect(() => {
    wrapTimeReport(initialization);
  }, []);

  const onToStudio = async (studio: IAPIGameItem) => {
    selectStudioDispatch({
      type: ReduxStudioActionType.SELECT_STUDIO,
      result: studio,
    });

    history.push({ pathname: `/studio/${studio.studioID}/portal` });
    return;
  };

  const initialization = async () => {
    setLoading(true);
    await getStudioList(gameStudioDispatch)();
    setShowPage(true);
    setLoading(false);
  };

  const renderEmptyStudioFrom = () => {
    return (
      <SimpleCardWrapper
        title={''}
        className={styles.studioSelectWrapper}
        isShowBrandLogo={true}
      >
        <EmptyStudio
          openCreateStudioModal={() => setShowCreateStudioModal(true)}
          openApplyJoinModal={() => setShowApplyJoinModal(true)}
        />
      </SimpleCardWrapper>
    );
  };

  const renderStudioList = () => {
    return (
      <SimpleCardWrapper
        title={
          <>
            {getFormatMessage('please_choose_a')}
            <span style={{ color: '#5764f1' }}>
              {getFormatMessage('studio')}
            </span>
          </>
        }
        className={styles.studioSelectWrapper}
      >
        <Spin spinning={loading}>
          <div className={styles.studioListBox}>
            {studioList.map((studio, index) => (
              <StudioItem
                key={index}
                onClick={() => onToStudio(studio)}
                name={studio.studioName}
              />
            ))}
          </div>
        </Spin>
        {!isSupportUser() && (
          <div className={styles.bottomBox}>
            <div
              className={styles.selectStudioBtnBox}
              onClick={() => setShowCreateStudioModal(true)}
            >
              <img src={CreatNewStudio} className={styles.createNewStudioBtn} />
              <span>{getFormatMessage('new_studio_button')}</span>
            </div>
            <div
              onClick={() => setShowApplyJoinModal(true)}
              className={styles.applyToJoinBtn}
            >
              {getFormatMessage('apply_to_join')}
            </div>
          </div>
        )}
      </SimpleCardWrapper>
    );
  };

  const renderAddStudioModal = () => {
    if (showCreateStudioModal) {
      return (
        <CreateStudioModal
          onToStudio={onToStudio}
          onReload={initialization}
          onClose={() => setShowCreateStudioModal(false)}
        />
      );
    }
  };

  const renderHeader = () => {
    if (!location.pathname.startsWith('/studio/select-studio')) {
      return <Header isTransparent={true} />;
    }
    return null;
  };

  const renderApplyJoinStudioModal = () => {
    if (showApplyJoinModal) {
      return <ApplyToJoinModal onClose={() => setShowApplyJoinModal(false)} />;
    }
  };

  if (!showPage) {
    return null;
  }

  return (
    <>
      {renderHeader()}
      {studioList.length ? renderStudioList() : renderEmptyStudioFrom()}
      {renderAddStudioModal()}
      {renderApplyJoinStudioModal()}
    </>
  );
};
